// extracted by mini-css-extract-plugin
module.exports = {"root":"NJck7","image":"s46v7","svg":"_1GuA4"};